



























































































import Vue from "vue";
import MapComp from "../components/Map.vue";
import BrandButton from "../components/BrandButton.vue";
import ToggleButton from "../components/ToggleButton.vue";

import slugify from "slugify";
import { verifyId } from "@/api/firebase";
import { mapGetters, mapState } from "vuex";
import PreventUnload from 'vue-prevent-unload';

import {loadGpx} from "../utils/UploadUtils"

enum OverlayState {
	None,
	New,
	Upload,
	Save_Name,
	Save_Id,
	Save_Done,
	Leave_Page,
}

export default Vue.extend({
	components: {
		MapComp,
		BrandButton,
		ToggleButton,
		PreventUnload,
	},

	data() {
		return {
			OverlayState,
			overlay: OverlayState.None,
			errorMessage: "",
			timeoutId: undefined as any,
			idInput: "",
			leaveFunc: undefined as any,
		}
	},

	computed: {
		base() : string {
			return window.location.origin;
		},

		id() : string {
			return this.$store.state.map ? this.$store.state.map.id : "";
		},

		matchRoute: {
			get() : boolean {
				return this.$store.state.matchRoute;
			},
			set(value) {
				this.$store.commit("setMatchRoute", value);
			}
		},

		...mapGetters("undo", ["canUndo", "canRedo"]),
		...mapState("undo", ["hasChanges"])
	},

	methods: {
		async save() {
			if(!this.$store.state.map.name) {
				this.overlay = OverlayState.Save_Name;
				return;
			} else if(!this.$store.state.map.id) {
				this.idInput = this.$store.state.map.id = slugify(this.$store.state.map.name);
				this.errorMessage = "";
				this.overlay = OverlayState.Save_Id;
				return;
			}

			// name and id is set, proceed with save
			this.$store.state.map.id = this.$store.state.map.id.toLowerCase();
			const {success, error} = await this.$store.dispatch("saveMap");
			if(success) {
				this.$router.replace(`/${this.id}/edit`)
				this.overlay = OverlayState.Save_Done;
			} else {
				this.$store.commit("alert/addMessage", error)
			}
		},

		cancel() {
			if(this.overlay == OverlayState.Save_Id)
				this.$store.state.map.id = "";
			this.overlay = OverlayState.None;
		},

		undo() {
			this.$store.dispatch("undo/undo");
		},

		redo() {
			this.$store.dispatch("undo/redo");
		},

		async loadFile(event) {
			try {
				const route = await loadGpx(event);
				console.log(route);
				if(route) {
					this.$store.dispatch("setRoute", route.map(c => [c]));
					(this.$refs.map as any).zoomTo("all", true);
	
					this.overlay = OverlayState.None;
				} else {
					throw new Error("no route");
				}
			} catch(err){
				this.$store.commit("alert/addMessage", "Kunde inte ladda filen. Kontrollera att det är en korrekt fil i gpx-format.")
			}
		},

		hijackLink(evt) {
			evt.preventDefault();
			this.$router.push(new URL(evt.target.href).pathname);
		},
	},

	beforeRouteLeave(to, from, next) {
		if(this.hasChanges) {
			this.leaveFunc = next;
			this.overlay = OverlayState.Leave_Page;
		} else {
			next();
		}
	},

	watch: {
		$route:{
			handler: function(to, from) {
				if(to.meta.isNew)
					this.$store.dispatch("newMap");
				else
					this.$store.dispatch("loadMap", to.params.id);
				
				
				if(to.meta.isNew == true)
					this.overlay = OverlayState.New;

			},
			immediate: true,
		},

		idInput(value) {
			this.$store.state.map.id = slugify(value);
		},

		async id(id) {
			if(this.overlay != OverlayState.Save_Id)
				return;
			
			if(this.timeoutId) {
				clearTimeout(this.timeoutId);
			}
			this.timeoutId = setTimeout(async () => {
				const { data } = await verifyId(id);
				if(data.id == id) {
					this.errorMessage = data.message;
				}
			}, 400)
		},

		overlay() {
			Vue.nextTick(() => {
				const input = this.$el.querySelector("input");
				if(input)
					input.focus();
			});
		}

		
	}

})
